import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import TurmaTableSelectRedux from "../Turma/TurmaTableSelectRedux";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import TurmaProfileRedux from "../Turma/TurmaProfileRedux";
import AlunoTurmaTable from "./AlunoTurmaTable";
import { useSelector } from "react-redux";
import AlunoTurmaFormContainer from "./AlunoTurmaFormContainer";
import { Grid } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { ADMIN, COORDENADOR } from "../Usuario/Perfil";
import { confirmAlert } from "react-confirm-alert";
import { gerarResultadoFinalPorInstituicao, gerarResultadoFinalPorTurma } from "./api-aluno-turma";
import { errorMessage, successMessage } from "../../util/ConfirmAlertUtil";
import {
  gerarMediaFinalPorInstituicao,
  gerarMediaFinalPorTurma,
} from "../NotaBimestre/api-nota-bimestre";

const useStyles = makeStyles({
  paper: {
    padding: "20px",
  },
  title: {
    marginBottom: "20px",
  },
  adicionarDisciplina: {
    paddingBottom: "10px",
  },
  formControl: {
    marginBottom: "10px",
  },
});

export default function AlunoTurmaContainer() {
  const classes = useStyles();
  const turma = useSelector((state) => state.turma);
  const alunoTurma = useSelector((state) => state.alunoTurma);
  const [anchorEl, setAnchorEl] = useState(null);
  const user = useSelector((state) => state.usuario);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleGerarMediaFinalPorTurma = () => {
    confirmAlert({
      title: "Alerta",
      message: "Gerar Média Final por Turma?",
      buttons: [
        {
          label: "Sim",
          onClick: () => {
            gerarMediaFinalPorTurma(turma.codigo).then((data) => {
              if (data) {
                if (data.error) {
                  errorMessage(data.message);
                } else {
                  successMessage("Operação sendo realizada em segundo plano. ");
                }
              }
            });
          },
        },
        {
          label: "Não",
          onClick: () => {},
        },
      ],
    });
  };
  const handleGerarMediaFinalPorInstituicao = () => {
    confirmAlert({
      title: "Alerta",
      message: "Gerar Média Final por Instituicao?",
      buttons: [
        {
          label: "Sim",
          onClick: () => {
            gerarMediaFinalPorInstituicao().then((data) => {
              if (data) {
                if (data.error) {
                  errorMessage(data.message);
                } else {
                  successMessage("Operação sendo realizada em segundo plano. ");
                }
              }
            });
          },
        },
        {
          label: "Não",
          onClick: () => {},
        },
      ],
    });
  };

  const handleGerarResultadoFinal = () => {
    confirmAlert({
      title: "Alerta",
      message: "Gerar Resultado Final para a Turma?",
      buttons: [
        {
          label: "Sim",
          onClick: () => {
            gerarResultadoFinalPorTurma(turma.codigo).then((data) => {
              if (data) {
                if (data.error) {
                  errorMessage(data.message);
                } else {
                  successMessage("Operação sendo realizada em segundo plano. ");
                }
              }
            });
          },
        },
        {
          label: "Não",
          onClick: () => {},
        },
      ],
    });
  };

  const handleGerarResultadoFinalPorInstituicao = () => {
    confirmAlert({
      title: "Alerta",
      message: "Gerar Resultado Final por Instituição?",
      buttons: [
        {
          label: "Sim",
          onClick: () => {
            gerarResultadoFinalPorInstituicao().then((data) => {
              if (data) {
                if (data.error) {
                  errorMessage(data.message);
                } else {
                  successMessage("Operação sendo realizada em segundo plano. ");
                }
              }
            });
          },
        },
        {
          label: "Não",
          onClick: () => {},
        },
      ],
    });
  };

  return (
    <div>
      <Container className={classes.paper} component={Paper}>
        {turma ? (
          <>
            <Grid container justifyContent="space-between">
              <Grid size={3}>
                <Typography className={classes.title} variant="h6">
                  Alunos Turma
                </Typography>
              </Grid>
              <Grid style={{ flexBasis: "5%" }} size={3}>
                {user.perfil === ADMIN || user.perfil === COORDENADOR ? (
                  <>
                    <MenuIcon
                      fontSize="small"
                      style={{ cursor: "pointer" }}
                      onClick={(event) => handleMenuClick(event)}
                      color="secondary"
                    />
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={handleGerarMediaFinalPorTurma}>
                        Gerar Média Final por Turma
                      </MenuItem>
                      <MenuItem onClick={handleGerarMediaFinalPorInstituicao}>
                        Gerar Média Final por Instituição
                      </MenuItem>
                      <MenuItem onClick={handleGerarResultadoFinal}>
                        Gerar Resultado Final por Turma
                      </MenuItem>
                      <MenuItem
                        onClick={handleGerarResultadoFinalPorInstituicao}
                      >
                        Gerar Resultado Final por Instituição
                      </MenuItem>
                    </Menu>
                  </>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
            <TurmaProfileRedux />
            {alunoTurma ? <AlunoTurmaFormContainer /> : <AlunoTurmaTable />}
          </>
        ) : (
          <>
            <Typography className={classes.title} variant="h6">
              Alunos Turma
            </Typography>

            <TurmaTableSelectRedux />
          </>
        )}
      </Container>
    </div>
  );
}
